import Splide from '@splidejs/splide';

export const init = () => {
  const carousels = document.querySelectorAll('.carousel_type-13');
  if (carousels.length > 0) {
    carousels.forEach((item) => {
      const numberOfItems = Number(item.dataset.itemsToDisplay);
      const splideCarousel = new Splide(item, {
        arrows: false,
        pagination: false,
        gap: 32,
        perPage: numberOfItems,
        perMove: 1,
        drag: true,
        speed: 1000,
        breakpoints: {
          1055: {
            perPage: 2,
          },
          671: {
            perPage: 1,
          },
        },
      });

      splideCarousel.mount();
      
      const arrowLeft = item.querySelector('.button--prev');
      const arrowRight = item.querySelector('.button--next');
      const { Controller } = splideCarousel.Components;
      if (arrowLeft && arrowRight) {
        if (Controller.getPrev() === Controller.getNext()) {
          arrowLeft.parentElement.classList.add('hidden');
        }
  
        splideCarousel.on('move', (newIndex) => {
          arrowLeft.classList.toggle('disabled', newIndex === 0);
          arrowRight.classList.toggle('disabled', newIndex === Controller.getEnd());
        });
  
        arrowLeft.addEventListener('click', () => splideCarousel.go('<'));
        arrowRight.addEventListener('click', () => splideCarousel.go('>'));
      }
    });
  }
};